var _path, _g, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDemoEp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Hand",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24,0V24H0V0Z",
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(7.05 5.65)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M0,4.79V1.15A1.2,1.2,0,0,1,1.23,0,1.188,1.188,0,0,1,2.46,1.15V5.51",
    transform: "translate(4.95 1.24)",
    fill: "none",
    stroke: "#8361DF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    strokeDasharray: "0 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,4.78V1.15A1.2,1.2,0,0,1,1.23,0,1.188,1.188,0,0,1,2.46,1.15V5.78",
    transform: "translate(2.48)",
    fill: "none",
    stroke: "#8361DF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    strokeDasharray: "0 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M7.42,4.34V1.41a1.233,1.233,0,0,1,2.46,0V5.69a4.772,4.772,0,0,1-4.94,4.6A4.778,4.778,0,0,1,0,5.69V1.15A1.2,1.2,0,0,1,1.23,0,1.2,1.2,0,0,1,2.46,1.15V2.61",
    transform: "translate(0 2.4)",
    fill: "none",
    stroke: "#8361DF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    strokeDasharray: "0 0"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M3,18.5a3,3,0,0,1-3-3V3A3,3,0,0,1,3,0H15.5a3,3,0,0,1,3,3V15.5a3,3,0,0,1-3,3Z",
    transform: "translate(2.75 2.75)",
    fill: "none",
    stroke: "#8361DF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    strokeDasharray: "0 0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDemoEp);
export default __webpack_public_path__ + "static/media/DemoEP.3329a9843e657328904e0ae12027bc14.svg";
export { ForwardRef as ReactComponent };